import RemoteService from '@avtechsoftware/ra-javascript-utilities/src/utilities/remoteService/remoteService';
import { clearMetricsGroupSlice } from '../slices/metricsGroupSlice/metricsGroupSlice';
import { clearThresholdRangeSlice } from '../slices/thresholdRangeSlice/thresholdRangeSlice';
import { clearDeviceListSlice } from '../slices/deviceList/deviceListSlice';
import { clearJwtSlice } from '../slices/jwtSlice';
import { clearProductsSlice } from '../slices/productsSlice/productsSlice';
import { clearAlertEventsSlice } from '../slices/alertEvents/alertEventsSlice';
import { clearSessionSlice } from '../slices/sessionSlice';
import envConfig from '../../envConfig';
import RaaAuthenticatedRemoteService from '../../utility/RaaAuthenticatedRemoteService';
import { clearSingleAlertSlice } from '../slices/singleAlertSlice/singleAlertSlice';
import { clearTagListSlice } from '../slices/tagListSlice/tagListSlice';
import { clearLinkListSlice } from '../slices/linkListSlice/linkListSlice';
import { clearAppliedDeviceSearch } from '../slices/filteredDeviceListSlice/filteredDeviceListSlice';
import { clearAppliedAlertSearch } from '../slices/alertListSlice/alertListSlice';
import { clearBillingSlice } from '../slices/billingSlice/billingSlice';

const securityMiddleware = () => (store) => (next) => async (action) => {
  if (action
        && typeof action.type === 'string'
        && action.type.includes('securedApi')
        && action.type.includes('rejected')) {
    if (action.payload
        && action.payload.name
        && action.payload.name === RemoteService.Errors.ForbiddenError) {
      store.dispatch(clearMetricsGroupSlice());
      store.dispatch(clearThresholdRangeSlice());
      store.dispatch(clearDeviceListSlice());
      store.dispatch(clearJwtSlice());
      store.dispatch(clearProductsSlice());
      store.dispatch(clearAlertEventsSlice());
      store.dispatch(clearSessionSlice());
      store.dispatch(clearSingleAlertSlice());
      store.dispatch(clearTagListSlice());
      store.dispatch(clearLinkListSlice());
      store.dispatch(clearAppliedDeviceSearch());
      store.dispatch(clearAppliedAlertSearch());
      store.dispatch(clearBillingSlice());
      const currentPath = window.location.pathname;
      window.location.assign(`${envConfig.raaUrl}/gateway?referrer=${currentPath.substring(1)}`);
      RaaAuthenticatedRemoteService.clearGlobalInstance();
    }
  }
  return next(action);
};

export default securityMiddleware();
